
const TIME_SEPARATOR = 'T';

const toDatePart = (dateString: string): string =>
  dateString.split(TIME_SEPARATOR)[0];

export const formatDateString = (dateString: string): string => {
  const [year, month, day] = toDatePart(dateString).split('-');
  return `${day}/${month}/${year}`;
};

export const parseDateStringLocal = (dateString: string): Date => {
  const [year, month, day] = toDatePart(dateString).split('-').map(Number);
  return new Date(year, month - 1, day);
};

export const isEndDateAfterStartDate = (startDate: string, endDate: string): boolean => {
  const start = parseDateStringLocal(startDate);
  const end = parseDateStringLocal(endDate);
  return end >= start;
};

export const isStartDateBeforeEndDate = (startDate: string, endDate: string): boolean =>
  parseDateStringLocal(startDate) < parseDateStringLocal(endDate);

export const isPastDate = (dateString: string): boolean => {
  if (!dateString) return false;
  const date = parseDateStringLocal(dateString);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date.getTime() < today.getTime();
};

export const todayIsoDate = (): string => {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
};
